<script setup lang="ts" name="FormWizardVerticalHeader">
import FormWizardVerticalHeaderTab from '~/components/FormWizardVerticalHeaderTab.vue';

defineProps<{
  step: number;
  title?: string;
  disabled?: boolean;
}>();
</script>

<template>
  <div class="w-full bg-charcoal-0 p-6">
    <FormWizardVerticalHeaderTab
      isActive
      :step="step"
      :isCompleted="false"
      :title="title"
      :disabled="disabled"
    />
  </div>
</template>
